<template>
  <div class="gm-field selector">
    <!-- Input field for UUID -->
    <label for="gameObjectId" class="gm-label">{{itemName}} Selector</label>
    <input
        type="text"
        id="gameObjectId"
        v-model="gameObjectId"
        class="gm-input"
        :placeholder="placeholder"
    />
    <!-- Button to confirm selection -->
    <button type="button" class="gm-btn gm-btn--sm selector-btn" @click="confirmSelection">Select</button>
  </div>
</template>

<script>
export default {
  name: "GameObjectRawSelector",
  props: {
    itemName: {
      type: String,
      default: "Location", // Name of the item being selected
    },
    placeholder: {
      type: String,
      default: "Enter UUID", // Placeholder text for the input field
    },
  },
  data() {
    return {
      gameObjectId: "", // Holds the entered UUID
    };
  },
  methods: {
    confirmSelection() {
      if (this.gameObjectId.trim() === "") {
        alert("Please enter a valid UUID.");
        return;
      }
      this.$emit("gameObjectSelected", this.gameObjectId);
    },
  },
};
</script>

<style scoped>
.selector {
  padding: var(--gm-gap-sm) 0;
}

.selector-btn {
  align-self: flex-end;
}
</style>
